module.exports = __webpack_public_path__ + "img/rotate-smartphone@3x.7c96df27.png";